import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
export const formatDate = (d, options) => new Date(d).toLocaleDateString('en-us', options || { year: 'numeric', month: 'long', day: 'numeric' });
export const formatTime = (d) => dayjs(d).format('LT');
export const currentDateTimeInMs = () => new Date().getTime();
export const currentTimeZone = () => {
    const tz = dayjs.tz.guess();
    return dayjs().tz(tz).format('zzz');
};
export const timeZoneAbbr = () => {
    const longName = currentTimeZone();
    return longName
        .split(' ')
        .map((word) => word.charAt(0))
        .join('');
};
export const getSplittedDayTime = (dateTime) => {
    const day = formatDate(dateTime, { day: 'numeric' });
    const month = formatDate(dateTime, { month: 'short' });
    const year = formatDate(dateTime, { year: 'numeric' });
    const hoursAndMinutes = formatTime(dateTime);
    return {
        day,
        month,
        year,
        hoursAndMinutes
    };
};
export const isTheSameDayFromUTC = (from, to) => {
    try {
        const dateFrom = new Date(from);
        const dateTo = new Date(to);
        const yearFrom = dateFrom.getUTCFullYear();
        const monthFrom = dateFrom.getUTCMonth();
        const dayFrom = dateFrom.getUTCDate();
        const yearTo = dateTo.getUTCFullYear();
        const monthTo = dateTo.getUTCMonth();
        const dayTo = dateTo.getUTCDate();
        return yearFrom === yearTo && monthFrom === monthTo && dayFrom === dayTo;
    }
    catch (error) {
        console.log(error);
        return false;
    }
};
export const dateIsInFuture = (date) => {
    const currentDate = new Date();
    const givenDate = new Date(date);
    return givenDate > currentDate;
};
